<footer class="bg-light text-center p-3 mt-5">
  @if (showLegalLinks()) {
    <p class="mb-2">
      <a routerLink="/terms" class="link-secondary text-decoration-none">Terms and Conditions</a>
      <span class="mx-2 text-muted">|</span>
      <a routerLink="/privacy" class="link-secondary text-decoration-none">Privacy Policy</a>
    </p>
  }
  <p class="mb-0">&copy;{{ copyrightYear }} EVready Energy <span class="text-muted">({{ appVersion }})</span></p>
</footer>
